import { helpers } from '@vuelidate/validators';

export default function (min) {
  return (value) => {
    return !helpers.req(value) || ((!/\s/.test(value) || value instanceof Date) && +(value.toString().replaceAll (',', '.')) >= +min)
  }
}